<section
  [ngStyle]="{ 'background-color': colorSelector() }"
  [ngClass]="{ 'teaser-long-text': isLongText || isMediumText }"
  class="teaser"
  (click)="navigateTo()"
  [appStoryblokEditable]="teaser._editable"
  appDisableClickEvent
>
  <picture class="teaser__image">
    <img [src]="teaser.image.filename" [alt]="teaser.image.alt" />
  </picture>
  <div [ngStyle]="{ 'background-color': colorSelector() }" class="teaser__wrapper">
    <div class="teaser__wrapper__content" [ngClass]="{ 'wrapper-long-text': isLongText }">
      <ng-container *ngIf="!isMobile; else MobileDevice">
        <h1
          [lang]="market"
          *ngIf="!isLongText"
          [ngClass]="{
            'teaser__wrapper__content__bg-yellow-title': teaser.color === 'primaryYellow',
            'teaser__wrapper__content__bg-rest-title': teaser.color !== 'primaryYellow'
          }"
          class="teaser__wrapper__content__title teaser__wrapper__content__title-short"
        >
          {{ teaser.text }}
        </h1>
        <h2
          [lang]="market"
          *ngIf="isLongText"
          [ngClass]="{
            'teaser__wrapper__content__bg-yellow-title': teaser.color === 'primaryYellow',
            'teaser__wrapper__content__bg-rest-title': teaser.color !== 'primaryYellow'
          }"
          class="teaser__wrapper__content__title teaser__wrapper__content__title-long"
        >
          {{ teaser.text }}
        </h2>
      </ng-container>
      <button
        type="button"
        [ngStyle]="{ 'background-color': colorSelector() }"
        class="teaser__wrapper__content__button"
        [ngClass]="{
          'teaser__wrapper__content__bg-yellow-button': teaser.color === 'primaryYellow',
          'teaser__wrapper__content__bg-rest-button': teaser.color !== 'primaryYellow'
        }"
        (click)="navigateTo()"
        appDisableClickEvent
      >
        {{ 'SHARED.DISCOVER_MORE.LABEL' | translate }}
      </button>
    </div>
  </div>
</section>

<ng-template #MobileDevice>
  <h3
    *ngIf="!isLongText"
    [ngClass]="{
      'teaser__wrapper__content__bg-yellow-title': teaser.color === 'primaryYellow',
      'teaser__wrapper__content__bg-rest-title': teaser.color !== 'primaryYellow'
    }"
    class="teaser__wrapper__content__title teaser__wrapper__content__title-short"
  >
    {{ teaser.text }}
  </h3>
  <h5
    *ngIf="isLongText"
    [ngClass]="{
      'teaser__wrapper__content__bg-yellow-title': teaser.color === 'primaryYellow',
      'teaser__wrapper__content__bg-rest-title': teaser.color !== 'primaryYellow'
    }"
    class="teaser__wrapper__content__title teaser__wrapper__content__title-long"
  >
    {{ teaser.text }}
  </h5>
</ng-template>
